var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-panel-list"},[_c('div',{staticClass:"panel-list-wrapper"},_vm._l((_vm.attributes.value),function(panel,index){return _c('panel',{key:("panel-" + index),attrs:{"attributes":panel}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }